export const SET_TERMS_OF_USE = "TERMS_OF_USE_SET_TERMS_OF_USE"
export const SET_ERROR = "TERMS_OF_USE_SET_ERROR";
export const CHANGE_ATTR = "TERMS_OF_USE_CHANGE_ATTR";
export const SET_TERMS_OF_USES = "TERMS_OF_USE_SET_TERMS_OF_USES"
export const RESET_TERMS_OF_USE_FORM = "TERMS_OF_USE_RESET_TERMS_OF_USE_FORM"
